"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.bold.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themeMapper = require("@gravity/theme-mapper");
var _classNames2 = _interopRequireDefault(require("./classNames"));
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/OverflowDetector.js",
  _templateObject,
  _templateObject2;
function cov_1hvq3a16n1() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/OverflowDetector.js";
  var hash = "88f227d97242a08de0349b519ac134bb140abd51";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/OverflowDetector.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 32
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 30
        }
      },
      "2": {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "3": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 45,
          column: 4
        }
      },
      "4": {
        start: {
          line: 47,
          column: 24
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "5": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 17
        }
      },
      "6": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "7": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 86
        }
      },
      "8": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 59
        }
      },
      "9": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 65
        }
      },
      "10": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 69
        }
      },
      "11": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 61
        }
      },
      "12": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 63
        }
      },
      "13": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 66
        }
      },
      "14": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 96
        }
      },
      "15": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 70
        }
      },
      "16": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 81
        }
      },
      "17": {
        start: {
          line: 83,
          column: 43
        },
        end: {
          line: 83,
          column: 78
        }
      },
      "18": {
        start: {
          line: 87,
          column: 43
        },
        end: {
          line: 87,
          column: 53
        }
      },
      "19": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 40
        }
      },
      "20": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 52
        }
      },
      "21": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      "22": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 66
        }
      },
      "23": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 13
        }
      },
      "24": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 40
        }
      },
      "25": {
        start: {
          line: 104,
          column: 23
        },
        end: {
          line: 104,
          column: 33
        }
      },
      "26": {
        start: {
          line: 105,
          column: 26
        },
        end: {
          line: 105,
          column: 55
        }
      },
      "27": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "28": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 47
        }
      },
      "29": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "30": {
        start: {
          line: 110,
          column: 69
        },
        end: {
          line: 110,
          column: 82
        }
      },
      "31": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 92
        }
      },
      "32": {
        start: {
          line: 115,
          column: 33
        },
        end: {
          line: 115,
          column: 43
        }
      },
      "33": {
        start: {
          line: 116,
          column: 60
        },
        end: {
          line: 116,
          column: 70
        }
      },
      "34": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 135,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 15,
            column: 9
          }
        },
        loc: {
          start: {
            line: 15,
            column: 24
          },
          end: {
            line: 15,
            column: 30
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        loc: {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 70
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 17
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 74
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 21
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 78
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 25
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 82
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 83,
            column: 18
          },
          end: {
            line: 83,
            column: 19
          }
        },
        loc: {
          start: {
            line: 83,
            column: 43
          },
          end: {
            line: 83,
            column: 78
          }
        },
        line: 83
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 21
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 86
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 93,
            column: 3
          }
        },
        line: 91
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 27
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 98
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        },
        loc: {
          start: {
            line: 114,
            column: 11
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 75,
            column: 11
          },
          end: {
            line: 75,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 11
          },
          end: {
            line: 75,
            column: 36
          }
        }, {
          start: {
            line: 75,
            column: 40
          },
          end: {
            line: 75,
            column: 95
          }
        }],
        line: 75
      },
      "1": {
        loc: {
          start: {
            line: 79,
            column: 25
          },
          end: {
            line: 79,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 53
          },
          end: {
            line: 79,
            column: 59
          }
        }, {
          start: {
            line: 79,
            column: 62
          },
          end: {
            line: 79,
            column: 68
          }
        }],
        line: 79
      },
      "2": {
        loc: {
          start: {
            line: 88,
            column: 11
          },
          end: {
            line: 88,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 11
          },
          end: {
            line: 88,
            column: 21
          }
        }, {
          start: {
            line: 88,
            column: 25
          },
          end: {
            line: 88,
            column: 39
          }
        }],
        line: 88
      },
      "3": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 99
      },
      "4": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 106
      },
      "5": {
        loc: {
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 57
          }
        }, {
          start: {
            line: 111,
            column: 61
          },
          end: {
            line: 111,
            column: 88
          }
        }],
        line: 111
      },
      "6": {
        loc: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 41
          }
        }, {
          start: {
            line: 127,
            column: 45
          },
          end: {
            line: 127,
            column: 85
          }
        }],
        line: 127
      },
      "7": {
        loc: {
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 132,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 128,
            column: 34
          }
        }, {
          start: {
            line: 129,
            column: 12
          },
          end: {
            line: 131,
            column: 29
          }
        }],
        line: 128
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "88f227d97242a08de0349b519ac134bb140abd51"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hvq3a16n1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hvq3a16n1();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OverflowDetectorWrapper = (cov_1hvq3a16n1().s[0]++, _styledComponents.default.div.attrs({
  className: 'stx-overflow-detect-wrapper'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  &.showAllContent {\n    > ", " {\n    }\n  }\n"])), function (_ref) {
  var target = _ref.target;
  cov_1hvq3a16n1().f[0]++;
  cov_1hvq3a16n1().s[1]++;
  return target;
}));
var OverflowButton = (cov_1hvq3a16n1().s[2]++, _styledComponents.default.button.attrs({
  className: 'stx-overflow-detect-button'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding: 0;\n  margin: 0;\n  z-index: 2;\n  border: none;\n  background: none;\n  outline: none;\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  color: var(--linkTextColor, #fe016b);\n  cursor: pointer;\n"])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.fontWeight.bold));
var OverflowDetector = /*#__PURE__*/function (_React$Component) {
  function OverflowDetector(props) {
    var _this;
    (0, _classCallCheck2.default)(this, OverflowDetector);
    cov_1hvq3a16n1().f[1]++;
    cov_1hvq3a16n1().s[5]++;
    _this = _callSuper(this, OverflowDetector, [props]);
    cov_1hvq3a16n1().s[6]++;
    _this.containerRef = /*#__PURE__*/_react.default.createRef();
    cov_1hvq3a16n1().s[7]++;
    _this.state = {
      isOverflow: false,
      noTargetElement: false,
      showAllContent: false
    };
    cov_1hvq3a16n1().s[8]++;
    _this.handleRefUpdate = _this.handleRefUpdate.bind(_this);
    cov_1hvq3a16n1().s[9]++;
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    cov_1hvq3a16n1().s[10]++;
    _this.toggleShowAllContent = _this.toggleShowAllContent.bind(_this);
    cov_1hvq3a16n1().s[11]++;
    _this.shouldShowButton = _this.shouldShowButton.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(OverflowDetector, _React$Component);
  return (0, _createClass2.default)(OverflowDetector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1hvq3a16n1().f[2]++;
      cov_1hvq3a16n1().s[12]++;
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1hvq3a16n1().f[3]++;
      cov_1hvq3a16n1().s[13]++;
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "getLabel",
    value: function getLabel(name) {
      var _this$props$labels;
      cov_1hvq3a16n1().f[4]++;
      cov_1hvq3a16n1().s[14]++;
      return (cov_1hvq3a16n1().b[0][0]++, (_this$props$labels = this.props.labels) === null || _this$props$labels === void 0 ? void 0 : _this$props$labels[name]) || (cov_1hvq3a16n1().b[0][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.Section.".concat(name),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 41
        }
      }));
    }
  }, {
    key: "getOverflowLabel",
    value: function getOverflowLabel() {
      cov_1hvq3a16n1().f[5]++;
      cov_1hvq3a16n1().s[15]++;
      return this.getLabel(this.state.showAllContent ? (cov_1hvq3a16n1().b[1][0]++, 'less') : (cov_1hvq3a16n1().b[1][1]++, 'more'));
    }
  }, {
    key: "toggleShowAllContent",
    value: function toggleShowAllContent() {
      cov_1hvq3a16n1().f[6]++;
      cov_1hvq3a16n1().s[16]++;
      this.setState(function (_ref2) {
        var showAllContent = _ref2.showAllContent;
        cov_1hvq3a16n1().f[7]++;
        cov_1hvq3a16n1().s[17]++;
        return {
          showAllContent: !showAllContent
        };
      });
    }
  }, {
    key: "shouldShowButton",
    value: function shouldShowButton() {
      cov_1hvq3a16n1().f[8]++;
      var _ref3 = (cov_1hvq3a16n1().s[18]++, this.state),
        isOverflow = _ref3.isOverflow,
        showAllContent = _ref3.showAllContent;
      cov_1hvq3a16n1().s[19]++;
      return (cov_1hvq3a16n1().b[2][0]++, isOverflow) || (cov_1hvq3a16n1().b[2][1]++, showAllContent);
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      cov_1hvq3a16n1().f[9]++;
      cov_1hvq3a16n1().s[20]++;
      this.handleRefUpdate(this.containerRef.current);
    }

    /**
     * @param {HTMLDivElement} element
     */
  }, {
    key: "handleRefUpdate",
    value: function handleRefUpdate(element) {
      cov_1hvq3a16n1().f[10]++;
      cov_1hvq3a16n1().s[21]++;
      if (element === null) {
        cov_1hvq3a16n1().b[3][0]++;
        cov_1hvq3a16n1().s[22]++;
        this.setState({
          isOverflow: false,
          noTargetElement: true
        });
        cov_1hvq3a16n1().s[23]++;
        return;
      } else {
        cov_1hvq3a16n1().b[3][1]++;
      }
      cov_1hvq3a16n1().s[24]++;
      this.containerRef.current = element;
      var _ref4 = (cov_1hvq3a16n1().s[25]++, this.props),
        target = _ref4.target;
      var targetElement = (cov_1hvq3a16n1().s[26]++, element.querySelector(target));
      cov_1hvq3a16n1().s[27]++;
      if (!targetElement) {
        cov_1hvq3a16n1().b[4][0]++;
        cov_1hvq3a16n1().s[28]++;
        this.setState({
          noTargetElement: true
        });
        cov_1hvq3a16n1().s[29]++;
        return;
      } else {
        cov_1hvq3a16n1().b[4][1]++;
      }
      var _ref5 = (cov_1hvq3a16n1().s[30]++, targetElement),
        clientWidth = _ref5.clientWidth,
        clientHeight = _ref5.clientHeight,
        scrollWidth = _ref5.scrollWidth,
        scrollHeight = _ref5.scrollHeight;
      cov_1hvq3a16n1().s[31]++;
      this.setState({
        isOverflow: (cov_1hvq3a16n1().b[5][0]++, clientWidth < scrollWidth) || (cov_1hvq3a16n1().b[5][1]++, clientHeight < scrollHeight)
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_1hvq3a16n1().f[11]++;
      var _ref6 = (cov_1hvq3a16n1().s[32]++, this.props),
        children = _ref6.children,
        target = _ref6.target;
      var _ref7 = (cov_1hvq3a16n1().s[33]++, this.state),
        isOverflow = _ref7.isOverflow,
        noTargetElement = _ref7.noTargetElement,
        showAllContent = _ref7.showAllContent;
      cov_1hvq3a16n1().s[34]++;
      return /*#__PURE__*/_react.default.createElement(OverflowDetectorWrapper, {
        target: target,
        className: (0, _classNames2.default)((0, _defineProperty2.default)({
          noTargetElement: noTargetElement,
          isOverflow: isOverflow,
          showAllContent: showAllContent
        }, "target-(".concat(target, ")"), target)),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.handleRefUpdate,
        className: "stx-overflow-detect",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 9
        }
      }, (cov_1hvq3a16n1().b[6][0]++, typeof children === 'function') && (cov_1hvq3a16n1().b[6][1]++, children({
        isOverflow: isOverflow,
        showAllContent: showAllContent
      })), (cov_1hvq3a16n1().b[7][0]++, this.shouldShowButton()) && (cov_1hvq3a16n1().b[7][1]++, /*#__PURE__*/_react.default.createElement(OverflowButton, {
        type: "button",
        onClick: this.toggleShowAllContent,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 13
        }
      }, this.getOverflowLabel()))));
    }
  }]);
}((_react.default.Component));
(0, _defineProperty2.default)(OverflowDetector, "propTypes", (cov_1hvq3a16n1().s[3]++, _propTypes.default.shape({
  target: _propTypes.default.string,
  children: _propTypes.default.func,
  labels: _propTypes.default.shape({
    more: _propTypes.default.string,
    less: _propTypes.default.string
  })
})));
(0, _defineProperty2.default)(OverflowDetector, "defaultProps", (cov_1hvq3a16n1().s[4]++, {
  target: null,
  children: null,
  labels: {}
}));
var _default = exports.default = (0, _reactIntl.injectIntl)(OverflowDetector);